/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *
 */

import type { Note } from '@models/note/note';
import type { SearchHit } from '@components/search/types';
import I18N from '@utils/i18n.base';

export function noteToHit(note: Note): SearchHit {
    return {
        id: note.id,
        title: note.name || note.path || I18N.note.untitled,
        subtitle: note.path,
        icon: note.noteType === 0 ? 'folder' : 'description',
        to: `/note/${note.path}`,
    };
}
